export default __webpack_public_path__ + "static/media/5.6f52d893.jpg";